import base from "./base";

export const get = async (url: string) => base.ky.get(url);

export const getEu = async (url: string) =>
  base.getEmpty(url, { prefixUrl: undefined });
